<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="CloseIcon" @click="close()" />
    </template>
    <template #title>Copyright owners</template>

    <Sheet.Body @scroll="handleScroll">
      <p class="mb-4 text-[14px] leading-[20px] text-gray-800">
        Select from this list of copyright owners and organizations to attribute
        ownership when you add your work to Dacr.
      </p>

      <div class="divide-y divide-gray-800/8 border-y border-gray-800/8">
        <CopyrightOwnerRow
          v-for="owner in owners"
          :key="owner.id"
          :owner="owner"
          :account="isAccount(owner)"
          :managed-by="isOrganization(owner) ? managedBy(owner) : ''"
          @edit="handleEdit(owner)"
          @remove="handleDelete(owner)"
        />
      </div>

      <button
        type="button"
        class="mt-4 flex w-fit items-center gap-2.5 font-medium text-green-700"
        @click="handleNew"
      >
        <span
          class="flex size-6 items-center justify-center rounded-full bg-green-700/10"
        >
          <AddIcon class="size-4" />
        </span>
        Add new copyright owner
      </button>
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { Sheet, useSheet } from '@dacr/library'
import { CloseIcon, AddIcon } from '@dacr/icons'
import CopyrightOwnerRow from './CopyrightOwnerRow.vue'
import { useCopyrightOwners } from './useCopyrightOwners'

const { close } = useSheet()

const {
  owners,
  isAccount,
  isOrganization,
  managedBy,
  handleScroll,
  handleNew,
  handleEdit,
  handleDelete,
} = useCopyrightOwners()
</script>
